export default function() {
    return {
        type: 'OFFLINE',
    }
}
